import React, { useEffect, useState } from 'react';
import { CheckCircle } from 'lucide-react';
const PURCHASES = [{
  name: 'Laura Fernández',
  city: 'Buenos Aires'
}, {
  name: 'Agustina Godoy',
  city: 'Rosario'
}, {
  name: 'María Fucchili',
  city: 'Córdoba'
}, {
  name: 'Carla Méndez',
  city: 'Mendoza'
}, {
  name: 'Sofía Ramírez',
  city: 'La Plata'
}, {
  name: 'Gabriela Torres',
  city: 'Salta'
}, {
  name: 'Lucía Benítez',
  city: 'Mar del Plata'
}, {
  name: 'Valentina López',
  city: 'Santa Fe'
}];
export function PurchasePopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(PURCHASES[0]);
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      showPopup();
    }, 5000);
    const showPopup = () => {
      // Pick random person
      const randomPerson = PURCHASES[Math.floor(Math.random() * PURCHASES.length)];
      setCurrentPurchase(randomPerson);
      setIsVisible(true);
      // Hide after 4 seconds
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
      // Schedule next popup (random between 8-15 seconds)
      const nextInterval = Math.random() * (15000 - 8000) + 8000;
      setTimeout(showPopup, nextInterval);
    };
    return () => clearTimeout(initialTimeout);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-40 bg-white rounded-lg shadow-xl p-4 border-l-4 border-[#10b981] animate-fade-in-up max-w-xs md:max-w-sm flex items-center gap-3" data-id="element-52">
      <div className="bg-green-100 p-2 rounded-full" data-id="element-53">
        <CheckCircle className="w-6 h-6 text-[#10b981]" data-id="element-54" />
      </div>
      <div data-id="element-55">
        <p className="font-bold text-gray-800 text-sm" data-id="element-56">
          {currentPurchase.name}
        </p>
        <p className="text-gray-600 text-xs" data-id="element-57">{currentPurchase.city}</p>
        <p className="text-[#10b981] text-xs font-semibold mt-1" data-id="element-58">
          acaba de comprar el MegaPack
        </p>
      </div>
    </div>;
}